var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIntellijIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_87_8173)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.09095 24.9598L0.365234 18.8341L4.20523 11.7026L15.2224 15.9998L8.09095 24.9598Z",
    fill: "url(#paint0_linear_87_8173)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0003 8.54864L31.406 27.0629L19.1088 32.0001L11.7031 27.2458L22.5374 16.0001L17.7831 5.62293L22.0346 0.50293L32.0003 8.54864Z",
    fill: "url(#paint1_linear_87_8173)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0003 8.54864L22.2632 20.0686L17.7832 5.62293L22.0346 0.50293L32.0003 8.54864Z",
    fill: "url(#paint2_linear_87_8173)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4057 26.56L2.56 31.2229L4.61714 24L7.31429 15.1314L0 12.6629L4.61714 0L14.6743 1.23429L24.5486 12.5257L15.4057 26.56Z",
    fill: "url(#paint3_linear_87_8173)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.2627 6.17139H26.0113V25.92H6.2627V6.17139Z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.0918 22.2173H15.4975V23.4516H8.0918V22.2173Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4395 10.24V8.73145H9.3252V10.24H10.5138V15.4057H9.3252V16.9143H13.4395V15.4057H12.2966V10.24H13.4395Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3712 17.0514C16.7312 17.0514 16.1826 16.9143 15.7712 16.6857C15.3597 16.4572 14.994 16.1372 14.7197 15.8172L15.8626 14.5372C16.0912 14.8114 16.3197 14.9943 16.5483 15.1314C16.7769 15.2686 17.0512 15.36 17.3254 15.36C17.6454 15.36 17.9197 15.2686 18.1483 15.04C18.3312 14.8114 18.4226 14.4914 18.4226 13.9886V8.73145H20.2512V14.08C20.2512 14.5829 20.2054 14.9943 20.0683 15.36C19.9312 15.7257 19.7483 16 19.474 16.2743C19.2454 16.5029 18.9254 16.7314 18.5597 16.8229C18.194 16.96 17.8283 17.0514 17.3712 17.0514Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_87_8173",
    x1: 0.360663,
    y1: 18.3262,
    x2: 15.2301,
    y2: 18.3262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.258,
    stopColor: "#F97A12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.459,
    stopColor: "#B07B58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.724,
    stopColor: "#577BAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#1E7CE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#087CFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_87_8173",
    x1: 11.7795,
    y1: 11.3738,
    x2: 36.3084,
    y2: 24.9464,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F97A12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.072,
    stopColor: "#CB7A3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.154,
    stopColor: "#9E7B6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.242,
    stopColor: "#757B91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.334,
    stopColor: "#537BB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.432,
    stopColor: "#387CCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.538,
    stopColor: "#237CE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.655,
    stopColor: "#147CEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792,
    stopColor: "#0B7CF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#087CFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_87_8173",
    x1: 28.9046,
    y1: 19.6184,
    x2: 22.0758,
    y2: -0.785756,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE315D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.078,
    stopColor: "#CB417E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#9E4E9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.247,
    stopColor: "#755BB4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.339,
    stopColor: "#5365CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.436,
    stopColor: "#386DDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.541,
    stopColor: "#2374E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.658,
    stopColor: "#1478F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.794,
    stopColor: "#0B7BF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#087CFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_87_8173",
    x1: 4.90057,
    y1: 7.53051,
    x2: 25.3824,
    y2: 41.408,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE315D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#F63462"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.104,
    stopColor: "#DF3A71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.167,
    stopColor: "#C24383"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.291,
    stopColor: "#AD4A91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#755BB4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.917,
    stopColor: "#1D76ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#087CFA"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_87_8173"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntellijIcon);
export default __webpack_public_path__ + "static/media/intellijIcon.a5999f159d9aa71be29f282564c2510c.svg";
export { ForwardRef as ReactComponent };